/**
 * Format dates from profile metrics JSONs to ensure that they're parsed correctly by date-fns.
 *
 * @function formatRawDate
 * @param raw Raw date string from profile metrics JSON.
 * @returns FOrmatted date string that can be parsed by date-fns.
 */
export function formatRawDate(raw: string | undefined) {
  if (!raw) return ''

  const [year, month, day] = raw.split('-')
  return `${month}/${day}/${year}`
}
